import React from 'react'

const YoutubPlayButton = (props)=>(
	<svg xmlns="http://www.w3.org/2000/svg" width="68" height="68" viewBox="0 0 68 68">
	  <g id="Group_6848" data-name="Group 6848" transform="translate(-181 -89)">
	    <circle id="Ellipse_1" data-name="Ellipse 1" cx="34" cy="34" r="34" transform="translate(181 89)" fill="rgba(0,0,0,0.8)"/>
	    <g id="movie" transform="translate(191 99)">
	      <g id="Group_15" data-name="Group 15">
	        <g id="Group_14" data-name="Group 14">
	          <path id="Path_445" data-name="Path 445" d="M170.667,138.933l14.4-10.8-14.4-10.8Z" transform="translate(-151.467 -104.133)" fill="#fab702"/>
	          <path id="Path_446" data-name="Path 446" d="M24,0A24,24,0,1,0,48,24,23.993,23.993,0,0,0,24,0Zm0,43.2A19.2,19.2,0,1,1,43.2,24,19.226,19.226,0,0,1,24,43.2Z" fill="#fab702"/>
	        </g>
	      </g>
	    </g>
	  </g>
	</svg>
)

export default YoutubPlayButton
